import PropTypes from 'prop-types';
import { useMemo } from 'react';
import ContextProviderUtilities from './ContextProviderUtilities';

const [useContext, Provider] = ContextProviderUtilities();

const useNgpFormContext = useContext;

export const NgpFormContextProviderUtilities = ({ children, formData }) => {
    const contextValue = useMemo(() => ({ formData }), [formData]);
    return <Provider value={contextValue}>{children}</Provider>;
};

NgpFormContextProviderUtilities.propTypes = {
    children: PropTypes.node,
    formData: PropTypes.object,
};

NgpFormContextProviderUtilities.defaultProps = {
    children: null,
    formData: {},
};
export default useNgpFormContext;
